import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import LoginSignup from "./LoginSignup";
import {
  setLoginCallLocation,
  setLoginModal,
  setLoginTab,
  setPropertyToSaveFrom,
  setShowContinueBtn,
  setShowSessionMsg,
} from "@/redux/login/loginSlice";
import { logOut } from "@/redux/user/userSlice";
import { getEventCategory, trackButtonClick } from "@/utils/analytics";
import { deleteCookie, getCookie, setCookie } from "@/utils/cookies";
import useWindowDimensions from "@/hooks/useWindowDimensions";
import useAuth from "@/components/common/header/useAuth";

const LoginModal = ({ popUpMsg }) => {
  const dispatch = useDispatch();
  const prevModalState = useRef(false);

  const show = useSelector((state) => state.login);
  const user = useSelector((state) => state.user);
  const { width } = useWindowDimensions();

  const { isUserLoggedIn, userName, userSignOut, userLastName } = useAuth();

  const [loginModal, setLoginModalState] = useState(show);
  const [activeTab, setActiveTab] = useState("loginTab");
  const [showTabs, setShowTabs] = useState(true);
  // const [shouldShowRegister, setShoulShowRegister] = useState(false);

  useEffect(() => {
    setLoginModalState(show?.loginModal);
    dispatch(setLoginCallLocation("Popup"));

    if (show?.loginTab === "regsiterTab") {
      setActiveTab(show.loginTab);
    }
    if (show?.showTabsInModal && !user.passwordExpired) {
      setShowTabs(true);
    } else {
      setShowTabs(false);
    }

    // Track modal opening
    if (show?.loginModal && !prevModalState.current) {
      trackButtonClick({
        eventName: "auth_modal_opened",
        eventSource:
          show?.loginTab === "regsiterTab" ? "Register Modal" : "Login Modal",
        eventCategory: getEventCategory(),
      });
    }

    // Update previous modal state
    prevModalState.current = show?.loginModal;
  }, [show, user.passwordExpired]);

  useEffect(() => {
    const cookies = document.cookie.split(";");
    const userEmailCookie = cookies.find((cookie) =>
      cookie.trim().startsWith("userEmail=")
    );

    getCookie("userEmail") === null || !getCookie("userEmail")
      ? dispatch(setLoginTab("regsiterTab"))
      : dispatch(setLoginTab("loginTab"));
  }, [show?.loginModal]);

  const handleClose = () => {
    // Handle password expiry by signing out user
    console.log("user ", user);
    if (user.passwordExpired) {
      userSignOut({});
      dispatch(logOut({ isUserLoggedIn: false }));
      deleteCookie("isLoggedIn");
    }

    // Track modal closing
    trackButtonClick({
      eventName: "auth_modal_closed",
      eventSource: activeTab === "regsiterTab" ? "Register Tab" : "Login Tab",
      eventCategory: getEventCategory(),
    });

    dispatch(setLoginModal(false));
    dispatch(setPropertyToSaveFrom(null));
    getCookie("userEmail") === null || !getCookie("userEmail")
      ? dispatch(setLoginTab("regsiterTab"))
      : dispatch(setLoginTab("loginTab"));

    dispatch(setShowSessionMsg(false));
    dispatch(setShowContinueBtn(false));
  };

  return (
    <Modal show={loginModal} onHide={handleClose} size="md">
      <Modal.Header closeButton id="login-modal-close-btn" style={{ borderBottom: "none" }}></Modal.Header>
      <Modal.Body style={{ padding: "30px" }}>
        {showTabs ? (
          <div className="login-pop">
            <ul className="d-flex gap-5">
              <li
                className={`cursor-pointer ${
                  activeTab === "loginTab" ? "active-tab" : ""
                }`}
                id="login-modal-signin-tab"
                onClick={() => {
                  dispatch(setLoginTab("loginTab"));
                  setActiveTab("loginTab");

                  const eventCategory = getEventCategory();
                  if (width > 991) {
                    trackButtonClick({
                      eventName: "register_popup_sign_in_click",
                      eventSource: "Signin tab click",
                      eventCategory: eventCategory,
                    });
                  } else {
                    trackButtonClick({
                      eventName: "mobile_sign_in_click",
                      eventSource: "Signin tab click",
                      eventCategory: eventCategory,
                    });
                  }
                }}
              >
                Sign In
              </li>
              <li
                className={`cursor-pointer ${
                  activeTab === "regsiterTab" ? "active-tab" : ""
                }`}
                id="login-modal-register-tab"
                onClick={() => {
                  dispatch(setLoginTab("regsiterTab"));
                  setActiveTab("regsiterTab");
                  dispatch(setShowContinueBtn(false));

                  const eventCategory = getEventCategory();
                  if (width > 991) {
                    trackButtonClick({
                      eventName: "register_popup_register_click",
                      eventSource: "Register tab click",
                      eventCategory: eventCategory,
                    });
                  } else {
                    trackButtonClick({
                      eventName: "mobile_register_click",
                      eventSource: "Register tab click",
                      eventCategory: eventCategory,
                    });
                  }
                }}
              >
                Register
              </li>
            </ul>
          </div>
        ) : (
          !user.passwordExpired && (
            <div className="loginmodal-heading">
              <span className="loginmodal-bold">Register with Hubzu</span> to
              "favorite" properties, submit bids 24/7, and receive instant
              updates.
            </div>
          )
        )}
        <LoginSignup
          isFromAlerts={"Y"}
          isOtpVerificationModal={true}
          popUpMsg={popUpMsg}
          passwordExpired={user.passwordExpired}
        />
      </Modal.Body>
    </Modal>
  );
};

export default LoginModal;
